import './kp-directory-tree.less';
import {ngComponentCssClass} from 'shared/utils/ng-@decorators';
import type {Directory} from 'typings/portaro.be.types';

export abstract class KpDirectoryTreeComponentController implements KpDirectoryTreeComponentBindings {
    public directory: Directory;
    public currentDirectory: Directory;
    public level = 1;

    public abstract onSelect(locals: { $directory: Directory });
}

/**
 * @ngdoc component
 * @name kpDirectoryTree
 * @module portaro.media-viewer
 *
 * @param {Directory} directory Parent directory.
 * @param {Directory} currentDirectory Current selected directory.
 * @param {function()} onSelect Function triggered if some directory is selected.
 * @param {Directory} onSelect.$directory Selected directory.
 * @param {number=} level Internal component input.
 *
 * @description
 * Component for rendering of directory tree.
 */
// eslint-disable-next-line max-classes-per-file
export default class KpDirectoryTreeComponent {
    public static componentName = 'kpDirectoryTree';

    @ngComponentCssClass('directory-tree')
    public templateUrl = require('./kp-directory-tree.tpl.pug');

    public bindings = {
        directory: '<',
        currentDirectory: '<',
        level: '<?',
        onSelect: '&'
    };

    public controller = KpDirectoryTreeComponentController;
}

interface KpDirectoryTreeComponentBindings {
    directory: Directory;
    currentDirectory: Directory;
    level: number;

    onSelect(locals: { $directory: Directory });
}
